"use client";

import { Icon, Typography } from "@kyan/ui";
import Link from "next/link";

import { useHelpButtonController } from "#/app/(desktop)/layouts/Header/components/HelpButton/HelpButton.controller";
import { routes } from "#/config/routes";

const classes =
  "text-textPrimary flex h-full items-center border-b border-transparent p-4 transition-colors";

const getRoutesWithLabel = (handleClickHelpButton: () => void) => [
  {
    label: (
      <div className="flex items-center gap-2">
        <Icon size="lg" name="surprise" />
        <Typography>Rewards</Typography>
      </div>
    ),
    path: routes.rewards.index,
  },
  {
    label: "Leaderboard",
    path: routes.rewards.leaderboard,
  },
  {
    label: "Settings",
    path: routes.portfolio.settings,
  },
  {
    label: "Help Center",
    onClick: handleClickHelpButton,
  },
];

export interface NavbarProps {
  handleCloseMenu: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ handleCloseMenu }) => {
  const { handleClick } = useHelpButtonController();

  const routesWithLabel = getRoutesWithLabel(handleClick);

  return (
    <nav className="grid">
      {routesWithLabel.map(({ label, path, onClick }) =>
        path ? (
          <Link
            key={path}
            href={path}
            className={classes}
            onClick={handleCloseMenu}
          >
            {label}
          </Link>
        ) : (
          <button key={label} className={classes} onClick={onClick}>
            {label}
          </button>
        ),
      )}
    </nav>
  );
};
